
import User from "@/store/modules/system/user/entity";
import { Component, Mixins, FormModalMixins,appConst} from "@/lib";
import HiCheckbox from "@/components/form/hi-checkbox.vue";
@Component({
    components: {HiCheckbox}
})
export default class CreateUser extends Mixins(FormModalMixins) {
    model: User = new User();
    created(){
        Object.assign(this.config, {modelTitleL: "Action.Add",labelWidth:100, okAction:"system/user/create"});
    }

    mounted(){
    }

    get selectList(){
        return this.$store.state.system.user.roles.map(item => {
            return {
                value:item.id,
                displayText:item.name
            }
        })
    }

    get businessGroupList() {
        return this.getCodeListByCategory(
        appConst.codeCategory.businessGroup)
    }
}
